import React, { useEffect, useCallback, useState} from 'react';
import MicroOffsetControl from './MicroOffsetControl.js';
import Notes from 'midi/Notes.js';
import {connect} from 'react-redux';

const {fromTranspose} = Notes;

const MicroTuningNote = ({note, effect}) => { 
    let _note = fromTranspose(note);
    let isBlack = _note.isBlackNote();
    return (
        <div className="micro-tuning-note">
          <div className={isBlack ? "black micro-piano-note" : "micro-piano-note"}>
            {note % 12 === 0 ? _note.toString() : ''}
          </div>
          <MicroOffsetControl note={note} effect={effect}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MicroTuningNote);
